export const API_BASE_URL = '/api';